import { render, staticRenderFns } from "./ProjectRoleTab.vue?vue&type=template&id=5da58bb2&scoped=true&"
import script from "./ProjectRoleTab.vue?vue&type=script&lang=js&"
export * from "./ProjectRoleTab.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRoleTab.vue?vue&type=style&index=0&id=5da58bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da58bb2",
  null
  
)

export default component.exports